<template>
  <div v-if="!WishList.length" class="wishlist-no-items-message">
    <div class="list-warning">{{ translate('You currently have no items on your wishlist.') }}</div>
  </div>
  <div id="eon-wishlist">
    <div class="eon-wishlist-container">
      <GlassItem
          @remove="onRemoveEvent" v-for="(glass, i) in  WishList"
          :Glassitem="glass"
          :lb_remove="translate('Remove')"
          :is-screen="true"
          :baseurl="'/' + language + '/' +  translate('model').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()  + '/'"
          :key="i"
          tagName="article"
          tag="otto"
      />
    </div>
    <div class="wishlist-download-button">
      <button v-if="WishList.length" class="btn btn-download" @click="generatePdf">
        <i class="fa fa-file-pdf btn-icon"> </i>{{ translate('Download') }}
      </button>
    </div>
  </div>
  <vue3-html2pdf
      :htmlToPdfOptions=merklistePdfOptions
      pdf-format="a4"
      :show-layout="false"
      :manual-pagination="true"
      pdf-content-width="190mm"
      ref="html2Pdf"
  >
    <template v-slot:pdf-content>
      <div id="eon-pdf-print-container" style="page-break-before: avoid; page-break-after: avoid">
        <img class="pdf-logo"
             src="data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e %3csvg version='1.1' id='layer' x='0px' y='0px' viewBox='-153 -46 600 50' xml:space='preserve' width='600' height='50' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cstyle type='text/css' id='style2'%3e.st0%7bfill:%23323232%3b%7d .st1%7bfill:%23323232%3b%7d%3c/style%3e%3cpolygon class='st0' points='-40.8%2c275.8 -17.3%2c275.8 -17.3%2c270.5 -40.8%2c270.5 -40.8%2c257 -15.2%2c257 -13.1%2c251.9 -48.5%2c251.9 -48.5%2c295.9 -12.9%2c295.9 -15.1%2c290.6 -40.8%2c290.6 ' id='polygon4' style='fill:%23141414%3bfill-opacity:1' transform='translate(-20%2c-296)'/%3e%3cpolygon class='st0' points='139.6%2c295.9 147.4%2c295.9 147.4%2c251.9 139.6%2c251.9 139.6%2c270.5 111.2%2c270.5 111.2%2c251.9 103.4%2c251.9 103.4%2c295.9 111.2%2c295.9 111.2%2c275.9 139.6%2c275.9 ' id='polygon6' style='fill:%23141414%3bfill-opacity:1' transform='translate(-20%2c-296)'/%3e%3cpolygon class='st0' points='169.5%2c275.8 193%2c275.8 193%2c270.5 169.5%2c270.5 169.5%2c257 195.1%2c257 197.2%2c251.9 161.8%2c251.9 161.8%2c295.9 197.5%2c295.9 195.2%2c290.6 169.5%2c290.6 ' id='polygon8' transform='translate(-20%2c-296)'/%3e%3cpolygon class='st0' points='216.8%2c260 243.1%2c295.9 252.4%2c295.9 252.4%2c251.9 244.6%2c251.9 244.6%2c286.2 219.5%2c251.9 209%2c251.9 209%2c295.9 216.8%2c295.9 ' id='polygon10' transform='translate(-20%2c-296)'/%3e%3cg id='g26' transform='translate(-20%2c-296)'%3e%3cpath class='st0' d='m 264.8%2c295.9 h 24.9 c 10.4%2c0 17.4%2c-5.1 17.4%2c-12.5 0%2c-2.6 -1%2c-4.8 -2.9%2c-6.7 -2.4%2c-2.3 -5.2%2c-3.5 -10.7%2c-4.5 3.1%2c-0.8 11.6%2c-3.1 11.6%2c-10.1 0%2c-6.1 -7.2%2c-10.3 -17.7%2c-10.3 h -22.6 z m 21.6%2c-21 c 8.3%2c0 12.7%2c2.9 12.7%2c8.2 0%2c4.9 -4.8%2c7.6 -13.3%2c7.6 h -13.1 v -15.9 h 13.7 z m -0.3%2c-18 c 7.1%2c0 10.8%2c2.1 10.8%2c6.1 0%2c4.4 -4%2c6.7 -12%2c6.7 h -12.3 v -12.8 z' id='path12'/%3e%3cpath class='st0' d='m 309.9%2c295.9 h 8 l 6.1%2c-10.6 h 28.7 l 6.1%2c10.6 h 7.9 l -24.9%2c-44 h -6.9 z m 39.6%2c-16.1 h -22.6 l 11.4%2c-20.1 z' id='path14'/%3e%3cpath class='st0' d='m 410.1%2c283.4 c -1.6%2c2.5 -2.4%2c3.5 -4.2%2c4.8 -3.3%2c2.5 -7.6%2c3.8 -12.1%2c3.8 -4.3%2c0 -18.3%2c-1.4 -18.3%2c-18 0%2c-10.6 7.6%2c-17.8 18.8%2c-17.8 10.6%2c0 13.5%2c6.3 15%2c9.5 l 6%2c-4 c -0.7%2c-2.1 -5.4%2c-11 -21.5%2c-11 -15.9%2c0 -26.7%2c9.8 -26.7%2c24.4 0%2c3.8 1.8%2c22.2 26.8%2c22.2 14.3%2c0 19.3%2c-6.6 21.5%2c-9.7 z' id='path16'/%3e%3cpolygon class='st0' points='460.4%2c295.9 468.2%2c295.9 468.2%2c251.9 460.4%2c251.9 460.4%2c270.5 432%2c270.5 432%2c251.9 424.2%2c251.9 424.2%2c295.9 432%2c295.9 432%2c275.9 460.4%2c275.9 ' id='polygon18'/%3e%3cpath class='st1' d='M -131.8%2c249.9 V 272 h 65 v -22.1 c 0%2c0 -11.2%2c9.2 -32.8%2c9.2 -21.7%2c0 -32.2%2c-9.2 -32.2%2c-9.2 m 0%2c50.2 V 278 h 65 v 22.1 c 0%2c0 -11.2%2c-9.2 -32.8%2c-9.2 -21.7%2c0 -32.2%2c9.2 -32.2%2c9.2' id='path20' style='fill:%23141414%3bfill-opacity:1'/%3e%3cpath class='st0' d='m -6.5%2c285.8 c 1.3%2c3.1 2.1%2c4.3 3.9%2c5.9 4.2%2c3.8 10.7%2c5.8 18.6%2c5.8 13.6%2c0 22.5%2c-5.6 22.5%2c-14.1 0%2c-10 -12.1%2c-12.6 -20.7%2c-14.1 -5.4%2c-1 -13.7%2c-2.6 -13.7%2c-6.7 0%2c-3.9 4.7%2c-6.3 12.1%2c-6.3 11.4%2c0 13.7%2c5.4 14.8%2c8.1 l 5.8%2c-4.2 c -1.4%2c-2.4 -5.1%2c-9.3 -20%2c-9.3 -12.4%2c-0.2 -20.8%2c4.6 -20.8%2c11.6 0%2c2.9 1.3%2c5.3 4.3%2c7.8 4.8%2c3.1 6.5%2c3.6 15.3%2c5.2 10.8%2c1.9 14.5%2c4.1 14.5%2c8.4 0%2c4.5 -5.6%2c8.2 -12.7%2c8.2 -4.9%2c0 -9%2c-1 -12%2c-3 -2.9%2c-1.8 -4.3%2c-3.8 -5.4%2c-7.5 z' id='path22'/%3e%3cpath class='st0' d='m 87.7%2c283.4 c -1.6%2c2.5 -2.4%2c3.5 -4.2%2c4.8 -3.3%2c2.5 -7.6%2c3.9 -12.1%2c3.9 -4.3%2c0 -18.3%2c-1.4 -18.3%2c-18 0%2c-10.6 7.6%2c-17.8 18.8%2c-17.8 10.6%2c0 13.5%2c6.3 15%2c9.5 l 6%2c-4 c -0.7%2c-2.1 -5.4%2c-11 -21.5%2c-11 -15.9%2c0 -26.7%2c9.8 -26.7%2c24.4 0%2c3.8 1.8%2c22.2 26.8%2c22.2 14.3%2c0 19.2%2c-6.6 21.5%2c-9.6 z' id='path24'/%3e%3c/g%3e%3c/svg%3e"
             alt="logo"
             style="page-break-before: avoid">
        <div class="pdf-date" style="page-break-before: avoid;page-break-after: avoid">
          {{ translate('Date') }}:<br>
          {{ localeDate() }}
        </div>
        <div style="break-before: avoid">
          <GlassItem
              @remove="onRemoveEvent" v-for="(glass, i) in  WishList"
              :Glassitem="glass"
              :lb_remove="translate('Remove')"
              :baseurl="'/' + language + '/' +  translate('model').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()  + '/'"
              :translate="translate"
              :key="i"
              :index="i"
          />
        </div>
      </div>

    </template>
  </vue3-html2pdf>
  <vue3-html2pdf
      :htmlToPdfOptions=artikelPdfOptions
      pdf-format="a4"
      :show-layout="false"
      :manual-pagination="true"
      pdf-content-width="190mm"
      ref="html2PdfSingle"
  >
    <template v-slot:pdf-content>
      <div id="eon-pdf-print-container-single" style="page-break-before: avoid; page-break-after: avoid">
        <img class="pdf-logo"
             src="data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e %3csvg version='1.1' id='layer' x='0px' y='0px' viewBox='-153 -46 600 50' xml:space='preserve' width='600' height='50' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cstyle type='text/css' id='style2'%3e.st0%7bfill:%23323232%3b%7d .st1%7bfill:%23323232%3b%7d%3c/style%3e%3cpolygon class='st0' points='-40.8%2c275.8 -17.3%2c275.8 -17.3%2c270.5 -40.8%2c270.5 -40.8%2c257 -15.2%2c257 -13.1%2c251.9 -48.5%2c251.9 -48.5%2c295.9 -12.9%2c295.9 -15.1%2c290.6 -40.8%2c290.6 ' id='polygon4' style='fill:%23141414%3bfill-opacity:1' transform='translate(-20%2c-296)'/%3e%3cpolygon class='st0' points='139.6%2c295.9 147.4%2c295.9 147.4%2c251.9 139.6%2c251.9 139.6%2c270.5 111.2%2c270.5 111.2%2c251.9 103.4%2c251.9 103.4%2c295.9 111.2%2c295.9 111.2%2c275.9 139.6%2c275.9 ' id='polygon6' style='fill:%23141414%3bfill-opacity:1' transform='translate(-20%2c-296)'/%3e%3cpolygon class='st0' points='169.5%2c275.8 193%2c275.8 193%2c270.5 169.5%2c270.5 169.5%2c257 195.1%2c257 197.2%2c251.9 161.8%2c251.9 161.8%2c295.9 197.5%2c295.9 195.2%2c290.6 169.5%2c290.6 ' id='polygon8' transform='translate(-20%2c-296)'/%3e%3cpolygon class='st0' points='216.8%2c260 243.1%2c295.9 252.4%2c295.9 252.4%2c251.9 244.6%2c251.9 244.6%2c286.2 219.5%2c251.9 209%2c251.9 209%2c295.9 216.8%2c295.9 ' id='polygon10' transform='translate(-20%2c-296)'/%3e%3cg id='g26' transform='translate(-20%2c-296)'%3e%3cpath class='st0' d='m 264.8%2c295.9 h 24.9 c 10.4%2c0 17.4%2c-5.1 17.4%2c-12.5 0%2c-2.6 -1%2c-4.8 -2.9%2c-6.7 -2.4%2c-2.3 -5.2%2c-3.5 -10.7%2c-4.5 3.1%2c-0.8 11.6%2c-3.1 11.6%2c-10.1 0%2c-6.1 -7.2%2c-10.3 -17.7%2c-10.3 h -22.6 z m 21.6%2c-21 c 8.3%2c0 12.7%2c2.9 12.7%2c8.2 0%2c4.9 -4.8%2c7.6 -13.3%2c7.6 h -13.1 v -15.9 h 13.7 z m -0.3%2c-18 c 7.1%2c0 10.8%2c2.1 10.8%2c6.1 0%2c4.4 -4%2c6.7 -12%2c6.7 h -12.3 v -12.8 z' id='path12'/%3e%3cpath class='st0' d='m 309.9%2c295.9 h 8 l 6.1%2c-10.6 h 28.7 l 6.1%2c10.6 h 7.9 l -24.9%2c-44 h -6.9 z m 39.6%2c-16.1 h -22.6 l 11.4%2c-20.1 z' id='path14'/%3e%3cpath class='st0' d='m 410.1%2c283.4 c -1.6%2c2.5 -2.4%2c3.5 -4.2%2c4.8 -3.3%2c2.5 -7.6%2c3.8 -12.1%2c3.8 -4.3%2c0 -18.3%2c-1.4 -18.3%2c-18 0%2c-10.6 7.6%2c-17.8 18.8%2c-17.8 10.6%2c0 13.5%2c6.3 15%2c9.5 l 6%2c-4 c -0.7%2c-2.1 -5.4%2c-11 -21.5%2c-11 -15.9%2c0 -26.7%2c9.8 -26.7%2c24.4 0%2c3.8 1.8%2c22.2 26.8%2c22.2 14.3%2c0 19.3%2c-6.6 21.5%2c-9.7 z' id='path16'/%3e%3cpolygon class='st0' points='460.4%2c295.9 468.2%2c295.9 468.2%2c251.9 460.4%2c251.9 460.4%2c270.5 432%2c270.5 432%2c251.9 424.2%2c251.9 424.2%2c295.9 432%2c295.9 432%2c275.9 460.4%2c275.9 ' id='polygon18'/%3e%3cpath class='st1' d='M -131.8%2c249.9 V 272 h 65 v -22.1 c 0%2c0 -11.2%2c9.2 -32.8%2c9.2 -21.7%2c0 -32.2%2c-9.2 -32.2%2c-9.2 m 0%2c50.2 V 278 h 65 v 22.1 c 0%2c0 -11.2%2c-9.2 -32.8%2c-9.2 -21.7%2c0 -32.2%2c9.2 -32.2%2c9.2' id='path20' style='fill:%23141414%3bfill-opacity:1'/%3e%3cpath class='st0' d='m -6.5%2c285.8 c 1.3%2c3.1 2.1%2c4.3 3.9%2c5.9 4.2%2c3.8 10.7%2c5.8 18.6%2c5.8 13.6%2c0 22.5%2c-5.6 22.5%2c-14.1 0%2c-10 -12.1%2c-12.6 -20.7%2c-14.1 -5.4%2c-1 -13.7%2c-2.6 -13.7%2c-6.7 0%2c-3.9 4.7%2c-6.3 12.1%2c-6.3 11.4%2c0 13.7%2c5.4 14.8%2c8.1 l 5.8%2c-4.2 c -1.4%2c-2.4 -5.1%2c-9.3 -20%2c-9.3 -12.4%2c-0.2 -20.8%2c4.6 -20.8%2c11.6 0%2c2.9 1.3%2c5.3 4.3%2c7.8 4.8%2c3.1 6.5%2c3.6 15.3%2c5.2 10.8%2c1.9 14.5%2c4.1 14.5%2c8.4 0%2c4.5 -5.6%2c8.2 -12.7%2c8.2 -4.9%2c0 -9%2c-1 -12%2c-3 -2.9%2c-1.8 -4.3%2c-3.8 -5.4%2c-7.5 z' id='path22'/%3e%3cpath class='st0' d='m 87.7%2c283.4 c -1.6%2c2.5 -2.4%2c3.5 -4.2%2c4.8 -3.3%2c2.5 -7.6%2c3.9 -12.1%2c3.9 -4.3%2c0 -18.3%2c-1.4 -18.3%2c-18 0%2c-10.6 7.6%2c-17.8 18.8%2c-17.8 10.6%2c0 13.5%2c6.3 15%2c9.5 l 6%2c-4 c -0.7%2c-2.1 -5.4%2c-11 -21.5%2c-11 -15.9%2c0 -26.7%2c9.8 -26.7%2c24.4 0%2c3.8 1.8%2c22.2 26.8%2c22.2 14.3%2c0 19.2%2c-6.6 21.5%2c-9.6 z' id='path24'/%3e%3c/g%3e%3c/svg%3e"
             alt="logo"
             style="page-break-before: avoid">
        <div class="pdf-date" style="page-break-before: avoid;page-break-after: avoid">
          {{ translate('Date') }}:<br>
          {{ localeDate() }}
        </div>
        <div style="break-before: avoid">
          <GlassItem
              v-if="singleItem"
              :Glassitem="singleItem"
              :lb_remove="translate('Remove')"
              :baseurl="'/' + language + '/' +  translate('model').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()  + '/'"
              :translate="translate"
          />
        </div>
      </div>

    </template>
  </vue3-html2pdf>
  <div style="display: none">
    <GlassImage ref="GlassImage" :imageUrl="ProductImage"/>
  </div>
</template>

<script>
import {nextTick, ref} from 'vue'
import {useStorage} from "vue3-storage";
import locales from "@/locales";
import {getAddButtons} from '@/composable/AppControls'
// hier wird das Json-Objekt geladen
import {fetchJsonObject} from '@/composable/fetchJsonObject'
import {waitUntil} from '@/composable/eonUtils'
import {Buffer} from 'buffer/';
import GlassItem from '@/components/glassitem'
import GlassImage from '@/components/product-image'
import {toast} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Vue3Html2pdf from 'vue3-html2pdf'

export default {
  name: 'App',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      generateArtNr: null,
    }
  },
  setup(properties, options) {
    // Items, Übersetzungen und Brands-Liste aus Datenquelle holen
    const {GlassesList, translation, brands} = fetchJsonObject()
    // Referenz für einzelnes Item von PDP
    const singleItem = ref(false)
    // Referenz für Glassitem-Komponente
    const GlassItem = ref({})
    // Referenz für angezeigte Wishliste
    const WishList = ref([])
    // Referenz für Hnzufügen-Buttons
    const addButtons = ref([])
    // Referenz für PDF-Buttons
    const pdfButtons = ref([])
    // Referenz für Local Storage im Browser
    const storage = useStorage();
    // Product Image
    const ProductImage = ref()
    // Die Config laden
    const config = options.attrs.cfg
    // Konfigurierte Sprache
    const language = config.language;
    // PDF Default Options
    const defaultPdfOptions = {
      margin: [10, 10, 10, 10],
      html2canvas: {
        allowTaint: true,
        useCORS: true,
        scale: 2,
      },
    };

    const isScreen = true
    return {
      GlassesList,
      GlassItem,
      singleItem,
      translation,
      WishList,
      addButtons,
      pdfButtons,
      storage,
      config,
      language,
      brands,
      toast,
      ProductImage,
      defaultPdfOptions,
      isScreen,
    }
  },
  mounted() {
    const self = this
    const observer = new MutationObserver(list => {
      const evt = new CustomEvent('glasses-list-changed', {detail: list});
      document.body.dispatchEvent(evt)
    });
    const glassesList = document.getElementById('glasses-list');
    if (glassesList) {
      observer.observe(glassesList, {
        attributes: false,
        childList: true,
        subtree: true
      });
      document.body.addEventListener(
          'glasses-list-changed',
          function () {
            self.addButtons = getAddButtons(self)
          }
      );
    }

    // soll erst ausgeführt werden wenn die Brillen-Liste geladen ist
    waitUntil(function () {
          return Array.isArray(self.GlassesList) && self.GlassesList.length > 0;
        }
        , function () {
          // Wishlist aus der Session
          self.loadWishlist()
          // Nach Button(s) zum Hinzufügen eines Items suchen
          self.addButtons = getAddButtons(self)
          // Daten-Attribute artnr und col des Hinzufügen-Buttons verweisen auf ein Modell mit Farbnummer.
          // Falls ein Item mit den Eigenschaften bereits in der Wishlist sind, wird der entsprechende Button deaktiviert
          for (const btn of self.addButtons) {
            const isInWishlist = self.inWishlist(btn.getAttribute("data-artnr"), btn.getAttribute("data-color-code"));
            btn.isInWishlist = isInWishlist;
            if (isInWishlist) btn.classList.add("eon-btn-selected");
          }
        }, 10000)
  },
  components: {
    GlassItem,
    GlassImage,
    Vue3Html2pdf
  },
  computed: {
    artikelPdfOptions() {
      const artNr = this.generateArtNr ? ' ' + this.generateArtNr : '';
      const artikelPdfName = locales?.[this.language]?.artikelPdfName ?? locales.en.artikelPdfName;
      return {
        ...this.defaultPdfOptions,
        filename: `${artikelPdfName}${artNr}.pdf`
      };
    },
    merklistePdfOptions() {
      const merklistePdfName = locales?.[this.language]?.merklistePdfName ?? locales.en.merklistePdfName;
      return {
        ...this.defaultPdfOptions,
        filename: `${merklistePdfName} - Eschenbach Eyewear.pdf`
      };
    }
  },
  methods: {
    /**
     * Ein Item zur Wishlist hinzufügenm
     * @param artNr
     * @param colNr
     */
    addToWishlist: function (artNr, colNr) {
      // Item in den Json-Daten suchen
      let itemFound = this.findItem(artNr, colNr)
      // Fehlermeldung falls nicht vorhanden
      if (!itemFound) {
        this.message('Could not add item to wishlist:' + artNr + ', col ' + colNr, 'warning')
        return
      }
      // Nur zur Wishlist hinzufügen, falls dort noch nicht vorhanden
      if (!this.inWishlist(artNr, colNr)) {
        // Item ohne Bild nicht anzeigen
        if (itemFound.colorImage.imageMissing) {
          this.message(this.translate('Could not add item to wishlist') + ' (' + this.translate('image missing') + '):' + artNr + ', col ' + colNr, 'warning')
        } else {
          this.ProductImage = this.config.glassesBaseUrl + itemFound.colorImage.image;
          // push in die angezeigte Liste
          this.WishList.push(itemFound)
          // Wishlist neu im Local Storage des Browsers speichern
          this.storeWishlist();
          this.onWishlistChanged()
        }
      }
    },
    /**
     * Das Item von der Produktseite, das via Button als PDF ausgegeben werden soll,
     * @param artNr
     * @param colNr
     */
    setSingleItem(artNr, colNr) {
      this.singleItem = this.findItem(artNr, colNr)
    },
    /**
     * Klickfunktion für den Hinzufügen-Button
     * @param btn
     * @param artNr
     * @param colNr
     */
    addToWishlistOnClick: async function (btn, artNr, colNr) {
      this.addToWishlist(artNr, colNr)
      this.disableButton(artNr, colNr)
    },
    /**
     * Klickfunktion für den Entfernen-Button
     * @param btn
     * @param artNr
     * @param colNr
     */
    removeFromWishlistOnClick: async function  (btn, artNr, colNr) {
      await this.removeFromWishlist(artNr, colNr)
      this.enableButton(artNr, colNr)
    },
    /**
     * Buttons mit Datenattribute artNr + colNr disablen
     * @param artNr
     * @param colNr
     */
    disableButton: function (artNr, colNr) {
      for (const btn of this.addButtons) {
        if (btn.getAttribute("data-artnr") === artNr && btn.getAttribute("data-color-code") === colNr) {
          btn.isInWishlist = true;
          btn.classList.add("eon-btn-selected");
        }
      }
    },
    /**
     * Buttons mit Datenattribute artNr + colNr enablen
     * @param artNr
     * @param colNr
     */
    enableButton: function (artNr, colNr) {
      for (const btn of this.addButtons) {
        if (btn.getAttribute("data-artnr") === artNr && btn.getAttribute("data-color-code") === colNr) {
          btn.isInWishlist = false;
          btn.classList.remove("eon-btn-selected")
        }
      }
    },
    /**
     * Ein Item aus der Daten-Quelle holen
     * @param articleNr
     * @param colorNr
     * @returns {boolean|{[p: string]: *}}
     */
    findItem(articleNr, colorNr) {
      // Artikel klonen
      let item = {
        ...this.GlassesList.filter(glass =>
            glass.article_nr.includes(articleNr)
        ).filter(x => typeof x !== undefined).shift()
      };
      // Wenn der Artikel nicht existiert...
      if (item.article_nr === undefined) {
        return false
      }
      // Artikel als Farbmodell definieren
      item.colorNr = colorNr
      item.colorImage = item.colors.filter(col => col.color_nr.includes(colorNr)).filter(x => typeof x !== undefined).shift();
      if (item.colorImage === undefined) {
        return false
      }
      // Label aus der Brandsliste ermitteln
      item.brandlabel = this.brands[item.brand]['label']
      return item
    },
    generatePdf() {
      this.$refs.html2Pdf.generatePdf();
    },
    generatePdfSingle(artNr) {
      this.generateArtNr = artNr;
      nextTick(() => {
        this.$refs.html2PdfSingle.generatePdf();
      });
    },
    /**
     * Existiert ein Item in der Wishlist?
     * @param artNr
     * @param colNr
     * @returns {boolean}
     */
    inWishlist: function (artNr, colNr) {
      return this.WishList.some(item => (item.colorNr === colNr && item.article_nr === artNr))
    },
    /**
     * Gibt das aktuelle Datum lokalisiert aus
     */
    localeDate: function () {
      const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      const today = new Date();
      if (this.language === 'de') {
        return today.toLocaleDateString('de-DE', options)
      }
      if (this.language === 'en') {
        return today.toLocaleDateString('en-GB', options)
      }
      if (this.language === 'fr') {
        return today.toLocaleDateString('fr-FR', options)
      }
      if (this.language === 'es') {
        return today.toLocaleDateString('es-ES', options)
      }
    },
    /**
     * Wishlist aus dem Local Storage des Browsers laden
     */
    loadWishlist: function () {
      // key ist eon-wishlist
      const storage = this.storage.getStorageSync("eon-wishlist")
      if (storage === undefined) {
        return;
      }
      // Hash decoden und in Array von Objekten konvertieren
      const buff = new Buffer(this.storage.getStorageSync("eon-wishlist"), 'base64');
      const json = buff.toString('utf8');
      const data = JSON.parse(json)

      // Alle Einträge durchlaufen
      for (const storageEntry of Object.values(data)) {
        // Prüfen ob das Item auch in der Datenquelle vorhanden ist
        const itemFound = this.findItem(storageEntry.articleNr, storageEntry.colorNr)
        if (itemFound) {
          if (itemFound.colorImage.imageMissing) {
            // Fehlermeldung wenn das Bild in der Datenquelle als missing gekennzeichnet ist
            this.message(this.translate('Cannot show item') + storageEntry.articleNr + ', col ' + storageEntry.colorNr + '. ' + this.translate('image missing') + '!', 'warning')
          } else {
            // Der Wishlist-Anzeige hinzufügen
            this.WishList.push(itemFound)
          }
        } else {
          // Fehlermeldung wenn das Item nicht in der Datenquelle existiert
          this.message(this.translate('Item not found') + ':' + storageEntry.articleNr + ', col ' + storageEntry.colorNr, 'warning')
        }
      }
    },
    /**
     * Toast-Message an den User
     * @param message
     * @param type
     */
    message: function (message, type) {
      const toastType = type !== undefined ? type : 'default'
      this.toast(message, {
        autoClose: 1000,
        position: this.toast.POSITION.TOP_CENTER,
        transition: this.toast.TRANSITIONS.SLIDE,
        type: toastType,
        hideProgressBar: true,
        dangerouslyHTMLString: true
      })
    },
    onWishlistChanged: async function () {
      await this.sleep(600);
      this.message(this.translate('Your wishlist has been updated') + this.$refs.GlassImage.$el.outerHTML)
    },
    /**
     * Wenn sich die Datenattribute im Button ändern
     * (@see: composable/Appcontrols.js)
     * Button aktivieren/deaktivieren
     * @param target
     */
    onChangeControl: function (target) {
      const artNr = target.getAttribute("data-artnr")
      const colNr = target.getAttribute("data-color-code")
      if (this.inWishlist(artNr, colNr)) {
        this.disableButton(artNr, colNr)
      } else {
        this.enableButton(artNr, colNr)
      }
    },
    /**
     * Wenn der RemoveButton geklickt ist
     * Aus Wishlist entfernen, Button enablen
     * @param obj
     */
    onRemoveEvent: function (obj) {
      this.removeFromWishlist(obj.article_nr, obj.colorNr)
      this.enableButton(obj.article_nr, obj.colorNr)
    },

    /**
     * Ein Item aus der Wishlist entfernen
     * @param artNr
     * @param colNr
     */
    removeFromWishlist: async function (artNr, colNr) {
      // Item aus der Wish
      let itemRemove = this.findItem(artNr, colNr)
      this.ProductImage = this.config.glassesBaseUrl + itemRemove.colorImage.image;
      this.WishList = this.WishList.filter(item => !(item.colorNr === colNr && (item.article_nr === artNr)))
      this.storeWishlist();
      this.onWishlistChanged()
    },
    sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
    /**
     * Wishlist im Local Store des Browsers speichern
     */
    storeWishlist: function () {
      const wishList = []
      for (const item of Object.values(this.WishList)) {
        wishList.push({articleNr: item.article_nr, colorNr: item.colorNr})
      }
      // Expire 30 Tage
      const expire = 1000 * 864000 * 3;
      const encoded = Buffer(JSON.stringify(wishList)).toString('base64')
      this.storage.setStorageSync("eon-wishlist", encoded, expire);
    },
    /**
     * String in aktuelle Sprache übersetzen
     * @param str
     * @returns {*}
     */
    translate: function (str) {
      if (this.language in this.translation && (str in this.translation[this.language])) {
        return this.translation[this.language][str]
      }
      return str;
    },
  }
}
</script>

